module.exports = __webpack_public_path__ + "static/media/ic-delete.6c5b0d70.svg";